<ul class="w-100 list-group rounded-0">
    
<app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_OneDrive">
    <li class="list-group-item d-block py-1">
        <div class="row w-100 d-flex align-items-center">
            <div class="col-12 text-truncate float-none form-check form-switch">
                <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="OneDrive" (change)="toggleShowPlugins($event)"
                [disabledByPermission]="permissionEnum.Perm_OneDrive" [checked]="oneDrive.enabled">
                <label class="col-10" for="OneDrive" translate="Sources.OneDrive"><app-info-button labelName="Settings.IntegrationsImportExportSection.OneDriveTooltip"></app-info-button></label>
            </div>
        </div>
    </li>
</app-hide-by-permission-wrapper>
<app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Sharepoint">
    <li class="list-group-item d-block py-1">
        <div class="row w-100 d-flex align-items-center">
            <div class="col-12 text-truncate float-none form-check form-switch">
                <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="SharePoint" (change)="toggleShowPlugins($event)"
                [disabledByPermission]="permissionEnum.Perm_Sharepoint" [checked]="sharePoint.enabled">
                <label class="col-10" for="SharePoint" translate="Sources.Sharepoint"><app-info-button labelName="Settings.IntegrationsImportExportSection.SharepointTooltip"></app-info-button></label>
            </div>
        </div>
    </li>
</app-hide-by-permission-wrapper>

    <!-- <li class="list-group-item d-block py-1">
        <div class="row w-100 d-flex align-items-center">
            <div class="col-12 text-truncate float-none form-check form-switch">
                <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="Teams" (change)="toggleShowPlugins($event)" [checked]="teams.enabled">
                <label class="col-10" for="Teams" translate="Sources.Teams"><app-info-button labelName="Settings.IntegrationsImportExportSection.TeamsTooltip"></app-info-button></label>
            </div>
        </div>
    </li> -->
</ul>